import { useRef } from 'react';
//
const useScrollToTop = () => {
  const scrollContainerRef = useRef(null);
  const handleScrollToTop = () => {
    if (scrollContainerRef?.current?.scrollTo) {
      scrollContainerRef?.current?.scrollTo({ x: 0, y: 0, animated: true });
    }
  };

  //
  return [scrollContainerRef, handleScrollToTop];
};

export default useScrollToTop;
